<template>
  <div
    class="carousel-list-wrapper-parts"
    :class="`carousel-list-wrapper-parts--${carouselListType}`"
  >
    <div
      class="carousel-list-wrapper-parts__content"
      ref="sceneListWrapperPartsContent"
      @scroll="checkCarouselEnabled"
    >
      <div class="carousel-list-wrapper-parts__list">
        <slot />
      </div>
    </div>
    <button
      v-if="enabledCarouselList"
      class="carousel-list-wrapper-parts__carousel carousel-list-wrapper-parts__carousel-prev"
      :class="{ 'carousel-list-wrapper-parts__carousel--active': enabledCarouselPrev }"
      @click="onclickCarousel('prev')"
    >
      <img :src="require('@/assets/img/icon/icon_chevron_left_24.svg')" alt="<" />
    </button>

    <button
      v-if="enabledCarouselList"
      class="carousel-list-wrapper-parts__carousel carousel-list-wrapper-parts__carousel-next"
      :class="{ 'carousel-list-wrapper-parts__carousel--active': enabledCarouselNext }"
      @click="onclickCarousel('next')"
    >
      <img :src="require('@/assets/img/icon/icon_chevron_right_24.svg')" alt=">" />
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from '@vue/composition-api'

export type CarouselListTypeData = 'video' | 'scene'

/**
 * HOME カルーセル付き リストWrapperパーツ
 */
export default defineComponent({
  name: 'CarouselListWrapperParts',
  components: {},
  props: {
    enabledCarouselList: {
      type: Boolean,
      default: false,
    },
    carouselListType: {
      type: String as PropType<CarouselListTypeData>,
      required: true,
    },
  },
  setup(props) {
    const enabledCarouselPrev = ref<boolean>(false)
    const enabledCarouselNext = ref<boolean>(false)

    const listCardWidth = computed(() => {
      switch (props.carouselListType) {
        case 'video':
          return -212
        case 'scene':
          return -170
        default:
          return -170
      }
    })

    const listPadding = computed(() => {
      switch (props.carouselListType) {
        case 'video':
          return 12
        case 'scene':
          return 6
        default:
          return 6
      }
    })

    return {
      enabledCarouselPrev,
      enabledCarouselNext,
      listCardWidth,
      listPadding,
    }
  },
  mounted() {
    // 読込時に表示判定
    setTimeout(() => this.checkCarouselEnabled(), 500)

    // リサイズ時に表示判定
    window.addEventListener('resize', this.checkCarouselEnabled)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkCarouselEnabled)
  },
  methods: {
    /**
     * カルーセルクリックアクション
     * @param type
     */
    onclickCarousel(type: 'prev' | 'next'): void {
      // スクロール量
      let scrollValue = this.listCardWidth

      // スクロールターゲット
      const sceneList = this.$refs.sceneListWrapperPartsContent as HTMLElement

      // nextの場合値をマイナス値へ
      scrollValue *= type === 'next' ? -1 : 1

      // スクロール実行
      sceneList.scroll({
        left: sceneList.scrollLeft + scrollValue,
        behavior: 'smooth',
      })
    },
    /**
     * ページャー有効化判定
     */
    checkCarouselEnabled() {
      const sceneList = this.$refs.sceneListWrapperPartsContent as HTMLElement

      this.enabledCarouselPrev = sceneList.scrollLeft > this.listPadding
      this.enabledCarouselNext =
        sceneList.scrollLeft < sceneList.scrollWidth - sceneList.clientWidth - this.listPadding
    },
  },
})
</script>

<style lang="scss" scoped>
.carousel-list-wrapper-parts {
  position: relative;
  width: 100%;

  &--video {
    .video-link-list-wrapper-parts {
      &__list {
        gap: 12px;

        &::after {
          min-width: 4px;
        }
      }
    }
  }

  &--scene {
    .video-link-list-wrapper-parts {
      &__list {
        gap: 6px;

        &::after {
          min-width: 10px;
        }
      }
    }
  }

  &__content {
    width: 100%;
    padding: 0 0 0 16px;
    overflow-y: hidden;
    overflow-x: auto;
  }

  &__list {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;

    &::after {
      display: block;
      content: '';
      min-width: 10px;
      height: 1px;
    }
  }

  &__carousel {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: calc(50% - 25px);
    width: 50px;
    height: 50px;
    background: $white;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    z-index: 4;
    transition: opacity ease 0.2s;
    opacity: 0;
    pointer-events: none;
    cursor: pointer;

    img {
      pointer-events: none;
    }

    &-prev {
      left: 10px;
    }

    &-next {
      right: 10px;
    }

    &--active {
      opacity: 1;
      pointer-events: auto;
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    &__content {
      padding-left: calc(50vw - 384px + 16px);
    }

    &--video {
      .video-link-list-wrapper-parts {
        &__list {
          &::after {
            min-width: calc(50vw - 384px + 4px);
          }
        }
      }
    }

    &--scene {
      .video-link-list-wrapper-parts {
        &__list {
          &::after {
            min-width: calc(50vw - 384px + 10px);
          }
        }
      }
    }
  }
}
</style>
